import { Injectable, inject } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';
import { PageTitleService } from '../services/page-title.service';

@Injectable()
export class JestyTitleStrategy extends TitleStrategy {
  private readonly pageTitle = inject(PageTitleService);
  private readonly transloco = inject(TranslocoService);
  private titleSub?: Subscription;

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    this.titleSub?.unsubscribe();

    // Route `title` alanı global çeviri anahtarı ise (ör. `titles.customers`) reaktif çevrilir:
    // selectTranslate çeviri yüklendiğinde ve dil değişiminde yeniden yayınlar. Aksi halde ham değer.
    if (title && this.isTranslationKey(title)) {
      this.titleSub = this.transloco.selectTranslate(title).subscribe((translated) => {
        this.pageTitle.set(translated && translated !== title ? translated : title);
      });
      return;
    }
    this.pageTitle.set(title || undefined);
  }

  private isTranslationKey(value: string): boolean {
    return /^titles\.[a-zA-Z]/.test(value);
  }
}
